import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M37.1777 44.4593L58.6655 23.2044C60.1577 21.7278 62.5635 21.7415 64.0395 23.2337C65.5151 24.7239 65.5019 27.1302 64.0102 28.6068L42.5225 49.8616C42.4941 49.89 42.4609 49.9315 42.4609 50.0003C42.4609 50.0687 42.4932 50.1102 42.5215 50.138L64.0102 71.3934C65.5019 72.8694 65.5146 75.2757 64.0395 76.7674C62.5635 78.2596 60.1577 78.2728 58.6655 76.7967L37.1768 55.5413C35.6836 54.0638 34.8613 52.096 34.8613 50.0008V50.0003C34.8613 47.9046 35.6836 45.9368 37.1777 44.4593Z'

const IconCaretLeft: FC<IconProps> = props => <SvgIcon {...props} path={PATH} />

export default IconCaretLeft
